import DEFAULT_PROPERTIES from './default';
import { LOGIN_METHOD_MICROSOFT } from './constants';

const VENA_ENERGY = {
    ...DEFAULT_PROPERTIES,
    appName: 'Vena Energy',
    shouldShowSignUp: false,
    clientId: '67e4901253c6f4e0fd667dbf',
    clientSecret:
        '01mnRqlgqfumbdxoLRoXYoZSS73GkEif4sWnOh06prGilFwAplUD19FNQzySiRlE6w',
    loginMethods: [LOGIN_METHOD_MICROSOFT],

    microsoftClientId: 'cb66abc1-bc32-4b18-8c9b-a0aa291aeda2',
    microsoftClientAuthority:
        'https://login.microsoftonline.com/0532e3ca-5510-49ca-a1ec-37a28a1a9c5a',
    wordpressDomain: 'https://joulebug.com',
    appStoreLink:
        'https://apps.apple.com/gb/app/cemex-always-in-action/id6444710005',
    playStoreLink:
        'https://play.google.com/store/apps/details?id=com.cleanbit.joulebug.pbj.cemex',
};
export default VENA_ENERGY;
